/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePostIncidentCommentRequest
 */
export interface CreatePostIncidentCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePostIncidentCommentRequest
     */
    comment: string;
}

/**
 * Check if a given object implements the CreatePostIncidentCommentRequest interface.
 */
export function instanceOfCreatePostIncidentCommentRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "comment" in value;

    return isInstance;
}

export function CreatePostIncidentCommentRequestFromJSON(json: any): CreatePostIncidentCommentRequest {
    return CreatePostIncidentCommentRequestFromJSONTyped(json, false);
}

export function CreatePostIncidentCommentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePostIncidentCommentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'comment': json['comment'],
    };
}

export function CreatePostIncidentCommentRequestToJSON(value?: CreatePostIncidentCommentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'comment': value.comment,
    };
}

